var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadAloudMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_555_1675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_1675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(9 9)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_555_1675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6564 15.1669L22.1939 10.2825C22.1705 10.0294 21.9689 9.82942 21.7158 9.80442L16.8314 9.34192H16.8251C16.7751 9.34192 16.7361 9.35754 16.7064 9.38723L9.3892 16.7044C9.37472 16.7189 9.36322 16.736 9.35538 16.7549C9.34754 16.7738 9.34351 16.7941 9.34351 16.8146C9.34351 16.835 9.34754 16.8553 9.35538 16.8742C9.36322 16.8931 9.37472 16.9103 9.3892 16.9247L15.0736 22.6091C15.1033 22.6388 15.1423 22.6544 15.1845 22.6544C15.2267 22.6544 15.2658 22.6388 15.2955 22.6091L22.6126 15.2919C22.6439 15.2591 22.6595 15.2138 22.6564 15.1669ZM15.183 21.0404L10.958 16.8154L17.2033 10.57L21.0626 10.9357L21.4283 14.795L15.183 21.0404ZM18.6251 11.9982C17.8673 11.9982 17.2501 12.6154 17.2501 13.3732C17.2501 14.131 17.8673 14.7482 18.6251 14.7482C19.383 14.7482 20.0001 14.131 20.0001 13.3732C20.0001 12.6154 19.383 11.9982 18.6251 11.9982ZM18.6251 13.8732C18.3486 13.8732 18.1251 13.6497 18.1251 13.3732C18.1251 13.0966 18.3486 12.8732 18.6251 12.8732C18.9017 12.8732 19.1251 13.0966 19.1251 13.3732C19.1251 13.6497 18.9017 13.8732 18.6251 13.8732Z",
    fill: "url(#paint0_linear_555_1675)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_555_1675",
    x: 0,
    y: 0,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_555_1675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_555_1675",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_555_1675",
    x1: 16.0365,
    y1: 22.7268,
    x2: 16.0365,
    y2: 9.34192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_555_1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadAloudMark);
export default __webpack_public_path__ + "static/media/read-aloud-mark.08d8c0bc21e8db853da4638a5c6dfaca.svg";
export { ForwardRef as ReactComponent };